import { c as _c } from "react/compiler-runtime";
import MUICircularProgress, { CircularProgressProps as MUICircularProgressProps } from '@mui/material/CircularProgress';
export interface Props extends Pick<MUICircularProgressProps, 'size' | 'sx'> {
  'aria-label': string;
  id?: string;
  isBig?: boolean;
  isCentered?: boolean;
  thickness?: 'small' | 'medium';
}
const Loader = t0 => {
  const $ = _c(18);
  let otherProps;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== t0) {
    ({
      size: t1,
      sx: t2,
      thickness: t3,
      isBig: t4,
      isCentered: t5,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = otherProps;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    otherProps = $[1];
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
  }
  const size = t1 === undefined ? 42 : t1;
  let t6;
  if ($[7] !== t2) {
    t6 = t2 === undefined ? {} : t2;
    $[7] = t2;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const sx = t6;
  const thickness = t3 === undefined ? "medium" : t3;
  const isBig = t4 === undefined ? false : t4;
  const isCentered = t5 === undefined ? false : t5;
  const computedSize = isBig ? 100 : size;
  const t7 = isCentered ? "auto" : undefined;
  const t8 = isCentered ? "block" : undefined;
  let t9;
  if ($[9] !== sx || $[10] !== t7 || $[11] !== t8) {
    t9 = {
      mx: t7,
      display: t8,
      ...sx
    };
    $[9] = sx;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const computedSx = t9;
  const t10 = thickness === "small" ? 2 : 3;
  let t11;
  if ($[13] !== computedSize || $[14] !== computedSx || $[15] !== otherProps || $[16] !== t10) {
    t11 = <MUICircularProgress color="primary" size={computedSize} sx={computedSx} thickness={t10} {...otherProps} />;
    $[13] = computedSize;
    $[14] = computedSx;
    $[15] = otherProps;
    $[16] = t10;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  return t11;
};
export default Loader;